// extracted by mini-css-extract-plugin
export default {"header":"Header_header__0wYwP","logo":"Header_logo__97EB7","logo_small":"Header_logo_small__PTFzm","menuIconArea":"Header_menuIconArea__qk9+p","menuIcon":"Header_menuIcon__Lvskv"};